export default "__VITE_ASSET__BUx1d$rP__"